import React, { useContext } from 'react';

import { ReactComponent as PaperPlaneIcon } from 'assets/icons/PaperPlane.svg';
import { ReactComponent as ThoughtsBubble } from 'assets/icons/ThoughtsBubble.svg';
import { ROUTE_SELECT_CHAT_MODAL } from 'routes';
import useOpenModal from 'helpers/useOpenModal';
import useThoughtsModal from 'helpers/useThoughtsModal';
import useTheme from 'helpers/useTheme';
import { COLORS } from 'styles/constants';

import { CardSchema, MessageType } from 'constants/graphqlTypes';

import { INavigation } from 'providers/helpers/models';
import { NavigationContext } from 'providers/helpers/contexts';
import { MenuWrapper } from 'components/UI/CardFooterMenu/styled';
import IconButton from 'components/UI/CardFooterMenu/IconButton';

interface SparkFooterMenuProps {
  spark: CardSchema;
  color?: string;
}

const SparkFooterMenu: React.FC<SparkFooterMenuProps> = ({ spark }) => {
  const isDark = useTheme();
  const buttonColor = isDark ? COLORS.white[100] : COLORS.brown.dark[100];
  const { isScrolled } = useContext<INavigation>(NavigationContext);
  const { id, pickId } = spark;

  // Send spark to chat using MessageType.Spark
  const goToChatSelect = useOpenModal(ROUTE_SELECT_CHAT_MODAL, false, {
    entityId: pickId || id,
    messageType: MessageType.Spark,
    collectionId: null,
    sparkPickId: id,
  });

  // Open thoughts modal, same as legacy CardFooterMenu
  const openThoughts = useThoughtsModal({
    id: pickId || id || '',
    openFromCardDetailPage: true,
  });

  return (
    <MenuWrapper>
      <IconButton
        ariaLabel="Thoughts"
        color={buttonColor}
        handleClick={(e) => {
          e.stopPropagation();
          if (!isScrolled) {
            openThoughts();
          }
        }}
      >
        <ThoughtsBubble />
      </IconButton>
      <IconButton
        ariaLabel="Send"
        color={buttonColor}
        handleClick={(e) => {
          e.stopPropagation();
          if (!isScrolled) {
            goToChatSelect();
          }
        }}
      >
        <PaperPlaneIcon />
      </IconButton>
    </MenuWrapper>
  );
};

export default SparkFooterMenu;
